import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../Contants';
import axios from '../../Util/axiosConfig';

// Dependencies
import Favorites from './Favorites';
import Checkouts from './Checkouts';

// MUI
import { Tab, Tabs, Paper, Box, Fab } from '@material-ui/core';

// Styles
import { CustomerHomeStyles } from '../styles/CustomerHome';
import ContactCard from '../LeadManagement/ContactCard';
import { Camera } from '@material-ui/icons';
import ScanningModal from '../LandingPage/Scanner/ScanningModal';

export default function CustomerHome() {
  const [selectedTab, setSelectedTab] = useState('Favorites');
  const [contactCardConfig, setContactCardConfig] = useState(undefined);
  const [tabArray, setTabArray] = useState(['Favorites', 'Sample Checkouts']);
  const [showScannerModal, setShowScannerModal] = useState(false);
  const CustHomeClasses = CustomerHomeStyles();

  useEffect(() => {
    const getContactCardConfig = async () => {
      const result = await axios.get(`${baseUrl}/api/account/rsa`);

      if (result.status !== 200) {
        setContactCardConfig(undefined);
        return;
      }

      if (
        Object.keys(result.data.rsa)?.length &&
        !tabArray.includes('Contact Sales')
      ) {
        setTabArray((prev) => {
          return [...prev, 'Contact Sales'];
        });
      }
      setContactCardConfig({ ...result.data.rsa });
    };

    getContactCardConfig();
  }, []);

  const changeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const modifiedTabName = index.toLowerCase().replace(' ', '-');

    return (
      <Box
        p={3}
        role="tabpanel"
        hidden={value !== index}
        id={'wrapped-tabpanel-' + modifiedTabName}
        aria-labelledby={'wrapped-tab-' + modifiedTabName}
        {...other}
      >
        {children}
      </Box>
    );
  }

  let contactTab;

  if (contactCardConfig && tabArray.find((i) => i === 'Contact Sales')) {
    contactTab = (
      <TabPanel value={selectedTab} index="Contact Sales">
        <ContactCard
          contactCardConfig={contactCardConfig}
          header={'Contact Sales'}
        />
      </TabPanel>
    );
  }

  return (
    <div>
      <Paper>
        {/* Full screen menu */}
        <Tabs
          TabIndicatorProps={{
            style: { backgroundColor: '#FF682C', color: '#FF682C' },
          }}
          className={CustHomeClasses.header}
          value={selectedTab}
          onChange={changeTab}
          centered
        >
          <Tab
            value={"Favorites"}
            label={"Favorites"}
            id={'wrapped-tab-favorites'}
            aria-controls={'wrapped-tabpanel-favorites'}
          />
          <Tab
            value={"Sample Checkouts"}
            label={"Sample Checkouts"}
            id={'wrapped-tab-sample-checkouts'}
            aria-controls={'wrapped-tabpanel-sample-checkouts'}
          />
          { contactCardConfig && tabArray.find((i) => i === 'Contact Sales') ? (
            <Tab
              value={'Contact Sales'}
              label={'Contact Sales'}
              id={'wrapped-tab-contact-sales'}
              aria-controls={'wrapped-tabpanel-contact-sales'}
            />
          ) : undefined }
        </Tabs>
      </Paper>
      <TabPanel value={selectedTab} index="Favorites">
        <Favorites isOpen={selectedTab === "Favorites"}/>
      </TabPanel>
      <TabPanel value={selectedTab} index="Sample Checkouts">
        <Checkouts isOpen={selectedTab === "Sample Checkouts"}/>
      </TabPanel>
      {contactTab}
      <Fab
        size="medium"
        variant="extended"
        style={{
          zIndex: '20',
          position: 'fixed',
          bottom: '0px',
          right: '0px',
          padding: '0px 12px',
          color: '#28C4FC',
          backgroundColor: '#142E3E',
          margin: '20px',
        }}
        onClick={() => setShowScannerModal(true)}
      >
        <Camera fontSize="small" style={{ marginRight: '5px' }} />
        Scan QR
      </Fab>
      <ScanningModal
        isOpen={showScannerModal}
        handleOnClose={() => setShowScannerModal(false)}
      />
    </div>
  );
};
